<template>
  <div class="base">
    <inside-header color="#fff" title="实名认证" back-link-name="TeacherIndex" />
    <div class="main">
      <div class="show-ips">
        <div class="item">
          1.实名认证有年龄限制，需年满18周岁及以上
        </div>
        <div class="item">
          2.当前只支持支付宝刷脸认证
        </div>
        <div class="item">
          3.需注册支付宝并且完成认证
        </div>
      </div>
      <a-skeleton v-show="loading" active />
      <div v-show="!loading" class="content">
        <div class="steps-area">
          <van-steps :active="current" active-color="#ff5c00">
            <van-step>填写基本资料</van-step>
            <van-step>支付宝认证</van-step>
            <van-step>认证完成</van-step>
          </van-steps>
        </div>
        <div v-show="current === 0" class="input-area">
          <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }" @submit="handleSubmit">
            <a-form-item label="姓名">
              <a-input v-decorator="['cert_name', { rules: [{ required: true, message: '请输入姓名' }] }]"
                placeholder="请输入姓名" />
            </a-form-item>
            <a-form-item label="身份证号码">
              <a-input v-decorator="['cert_no', { rules: [{ required: true, message: '请输入身份证号' }] }]"
                placeholder="请输入身份证号" />
            </a-form-item>
            <a-form-item>
              <div v-if="isWxClient">
                当前为微信环境，不能使用支付宝人脸识别认证。请前往浏览器进行认证
              </div>
              <a-button v-else type="primary" html-type="submit" :loading="state.startAuthBtn">
                提交
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <div v-show="current === 1" class="input-area">
          <div id="alipayHtml" ref="qrcode" class="show-pay-body" v-html="alipayHtml" />
          <div id="qrcode" ref="qrcode" style="width: 128px;height: 128px;margin: auto" />
        </div>
        <div v-show="current === 2" class="input-area">
          <a-result status="success" title="实名认证成功" sub-title="你已认证成功，现在去挑选家教老师吧">
            <template #icon>
              <img style="" src="@/assets/success.png" alt="">
            </template>
            <!-- <template #extra>
              <a-button @click="goTutorList" type="primary">
                找家教
              </a-button>
            </template> -->
          </a-result>
        </div>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import QRCode from 'qrcodejs2'
import { getIsWxClient } from '@/utils/util'

export default {
  name: 'TeacherSettingRealname',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      loading: true,
      state: {
        startAuthBtn: false
      },
      info: {},
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      editInfo: false,
      current: 0,
      stepStatus: 'process', // wait, process, finish, error
      qrcode: null,
      alipayHtml: '',
      isWxClient: false
    }
  },
  watch: {
    info(data) {
      if (data.status === 1) {
        this.current = 2
        this.stepStatus = 'finish'
      } else {
        this.form.setFieldsValue({ cert_name: data.auth_real_name, cert_no: data.auth_card_number })
        var isWxClient = getIsWxClient()
        if (isWxClient) {
          this.isWxClient = true
          this.$toast.fail('当前为微信环境，请前往浏览器进行认证')
        }
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: '/index/realname/info',
        method: 'get'
      }).then(res => {
        if (res.status === 'success') {
          this.loading = false
          this.info = res.data
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      // eslint-disable-next-line handle-callback-err
      this.form.validateFields((err, values) => {
        if (!err) {
          this.state.startAuthBtn = true
          this.$http({
            url: '/index/realname/startAuth',
            method: 'post',
            data: values
          }).then(res => {
            this.state.startAuthBtn = false
            if (res.status === 'success') {
              // 跳转
              this.alipayHtml = res.data.html
              setTimeout(function () {
                const payForm = document.getElementById('alipayHtml').querySelector('form')
                payForm.submit()
              }, 500)
              const scanUrl = res.data.scan_url
              this.current = 1
              this.bindQRCode(scanUrl)
              this.$toast.success('请使用支付宝扫描二维码')
              // 开始轮询
              this.queryAuth()
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    },
    bindQRCode(text) {
      var qrcode = new QRCode('qrcode', {
        text: text,
        width: 128,
        height: 128,
        colorDark: '#333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.H
      })
      this.qrcode = qrcode
    },
    queryAuth() {
      const that = this
      var cron = setInterval(function () {
        that.$http({
          url: '/index/realname/query',
          method: 'get'
        }).then(res => {
          // 如果存在停止信号
          if (res.data.stop) {
            clearInterval(cron)
          }
          if (res.status === 'success') {
            // passed为T
            if (res.data.passed === 'T') {
              that.current = 2
              that.stepStatus = 'finish'
              that.$toast.success('实名认证成功')
            } else {
              // 继续
            }
          } else {
            that.$toast.fail(res.message)
          }
        })
      }, 3000)
    },
    goTutorList() {
      this.$router.push({ name: 'TutorList' })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .main {
    padding: 15px;
  }
  .show-ips {
    width: 100%;
    height: 101px;
    padding: 18px 20px;
    background-color: #f6f6f6;
    border-radius: 10px;

    .item {
      font-family: MicrosoftYaHeiLight;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #333333;
    }
  }

  .steps-area {
    margin-top: 40px;
  }

  .input-area {
    margin-top: 40px;
  }

</style>
